<template>
  <!-- Dynamische Padding-Klassen basierend auf Bildschirmgröße -->
  <v-container fluid :class="containerClasses" class="bg-amber-darken-3">

    <div class="text-center mb-10">
      <!-- Responsive Textgrößen -->
      <h1 :class="titleClasses">Die Zusammenarbeit im Überblick</h1>
      <p :class="subtitleClasses">
        In 4 Schritten zum Erfolg
      </p>
    </div>

    <v-row
      class="mb-6 mx-auto"
      :class="rowClasses"
      no-gutters
    >
      <v-col cols="12">
        <!-- Timeline mit dynamischer Ausrichtung -->
        <v-timeline
          :density="timelineDensity"
          class="timeline-responsive text-left"
          :side="timelineSide"
          :align="timelineAlign"
        >
          <!-- STEP 1 - Beispiel mit responsive Icon-Größe -->
          <v-timeline-item 
            dot-color="blue-lighten-2"
            icon="mdi-email-outline"
            size="large"
            fill-dot
          >
            <template v-slot:opposite>
              <div class="step-number text-center text-blue-darken-2">1</div>
            </template>
            <div>
              <h2 class="mt-n1 font-weight-light mb-4 text-blue-darken-2" :class="stepTitleClasses">
                Kontakt & Erstgespräch
              </h2>
              <div :class="stepContentClasses">
                Schreibe uns oder buche direkt ein kostenloses Kennenlerngespräch.
                Wir analysieren gemeinsam deinen aktuellen Außenauftritt und
                identifizieren ungenutzte Potenziale.
              </div>
            </div>
          </v-timeline-item>

          <!-- STEP 2 -->
          <v-timeline-item 
            dot-color="green-lighten-2"
            size="small"
            icon="mdi-chart-bar"
            fill-dot
          >
            <template v-slot:opposite>
              <div class="step-number text-center text-green-darken-2">2</div>
            </template>
            <div>
              <h2 class="mt-n1 font-weight-light mb-4 text-green-darken-2" :class="stepTitleClasses">
                Strategie & Konzept
              </h2>
              <div :class="stepContentClasses">
                Wir entwickeln eine individuelle Content-Strategie
                zugeschnitten auf deine Marke, Zielgruppe und Unternehmensziele.
              </div>
            </div>
          </v-timeline-item>

          <!-- STEP 3 -->
          <v-timeline-item 
            dot-color="orange-lighten-2"
            size="x-large"
            icon="mdi-camera-outline"
            fill-dot
          >
            <template v-slot:opposite>
              <div class="step-number text-center text-orange-darken-2">3</div>
            </template>
            <div>
              <h2 class="mt-n1 font-weight-light mb-4 text-orange-darken-2" :class="stepTitleClasses">
                Umsetzung & Content-Produktion
              </h2>
              <div :class="stepContentClasses">
                Wir übernehmen Planung, Koordination und Umsetzung von Inhalten.
              </div>
            </div>
          </v-timeline-item>

          <!-- STEP 4 -->
          <v-timeline-item 
            dot-color="purple-lighten-2"
            size="small"
            icon="mdi-chart-line"
            fill-dot
          >
            <template v-slot:opposite>
              <div class="step-number text-center text-purple-darken-2">4</div>
            </template>
            <div>
              <h2 class="mt-n1 font-weight-light mb-4 text-purple-darken-2" :class="stepTitleClasses">
                Auswertung & Optimierung
              </h2>
              <div :class="stepContentClasses">
                Du bekommst alle Inhalte fertig und danach optimieren wir weiter.
              </div>
            </div>
          </v-timeline-item>

        </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useResponsive } from '@/composables/useResponsive';

export default defineComponent({
  name: 'MethodologyComponent',
  
  setup() {
    const responsive = useResponsive();
    return {
      ...responsive,
    };
  },
});
</script>

<style scoped>
.step-number {
  font-size: 2rem;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.2);
}

/* Zusätzliche mobile Optimierungen */
@media (max-width: 600px) {
  .timeline-responsive {
    padding-left: 8px;
    padding-right: 8px;
  }
  
  .step-number {
    font-size: 1.5rem;
  }
}
</style>